/**
 * SearchService
 *
 * @author Copyright (c) 2021 Salesforce.com.
 * @ownership Appexchange Everywhere
 */
import { APPX_SITE_API_URL } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { handleException } from '~/modules/utilities/error_utilities';
import { http, HttpRequestConfig } from '~/modules/utilities/http';
import { Category, Content, Section } from '../../schemas/content-schema-v1';
import { buildHomeCategorySection, buildHomeListingSection } from '../helpers/contentFeedHelper';
import { buildHomeContentSections } from '../helpers/contentSectionHelper';

export interface SectionsResult {
    sections: Section[];
    headers: Record<string, string>;
}

export class ContentService {
    async getSections(isGuestUser: boolean): Promise<SectionsResult> {
        try {
            const language = getUserLanguage();
            const response = await http.get(
                `${APPX_SITE_API_URL}/home_content?language=${language}&isGuestUser=${isGuestUser}`,
            );
            const headers = response.headers as Record<string, string>;

            // Filter nulls values + Map Feeds Api to Section Type
            const sections = buildHomeContentSections(response.data);
            return { sections, headers };
        } catch (error) {
            handleException(error, 'contentService.getSections');
            return {
                sections: [],
                headers: {},
            };
        }
    }
    async getFeeds(url: string): Promise<Content[] | Category[]> {
        const encodedURL = encodeURI(url);
        const httpConfig: HttpRequestConfig = {};

        const response = await http.get(`${APPX_SITE_API_URL}${encodedURL}`, httpConfig);
        const { categories, listings } = response?.data ?? {};

        if (categories) {
            return buildHomeCategorySection(categories);
        }

        if (listings) {
            return buildHomeListingSection(listings);
        }

        return [];
    }
}
